import '~/scss/app.scss';
import runCarouselFrontend from '~/blocks/carousel/frontend/run-carousel-frontend';
import makeAccordions from '~/blocks/accordion/frontend/make-accordions';
import makeModals from '~/blocks/modal/frontend/make-modals';
import makeFloatingBanners from '~/blocks/floating-banner/frontend/make-floating-banners';
import makeGalleries from '~/blocks/gallery/frontend/make-galleries';
import setupWidgets from '~/blocks/widget/frontend/setup-widget';
import makeDataTables from '~/blocks/table/frontend/make-data-tables';
import animateMobileMenu from '~/js/mobile-menu';
import appendSpanStylesToCheckbox from '~js/form/form';

function app() {
  animateMobileMenu();
  runCarouselFrontend();
  makeAccordions();
  makeModals();
  makeFloatingBanners();
  makeGalleries();
  setupWidgets();
  makeDataTables();
  appendSpanStylesToCheckbox();
}

document.addEventListener('DOMContentLoaded', app);
